import { AnyAction, Dispatch } from 'redux'
import { ActionFunctionAny } from 'redux-actions'

// redux-form integration with redux-saga
const bindSubmitActionToPromise = (
  dispatch: Dispatch,
  action: ActionFunctionAny<AnyAction>
) => (formData: any) =>
  new Promise((resolve, reject) =>
    dispatch(action({ formData, resolve, reject }))
  )

// redux-form integration with redux-saga
const bindSubmitActionToPromiseWithArgs = (
  dispatch: Dispatch,
  action: ActionFunctionAny<AnyAction>,
  args?: any
) => (formData: any) =>
  new Promise((resolve, reject) =>
    dispatch(action({ formData, resolve, reject, args }))
  )

export { bindSubmitActionToPromise, bindSubmitActionToPromiseWithArgs }
